export default __webpack_public_path__ + "assets/students-empty-state-3997442.svg";